import { Grid, Typography } from '@material-ui/core';
import { Button, TestDataAttribute } from '@roc/ui';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { INSPECTION_BY_BORROWER } from '../../utils/constants';

export const SubmitAppraisalSuccess = observer(({ store }) => {
  const { submittedAppraisalId } = store;

  const startAnotherOrder = () => {
    store.reset();
  };

  const getSuccessMessage = () => {
    return 'Your appraisal has been ordered. Thank You.';
  };

  return (
    <Grid container direction="column" alignItems="center" spacing={4}>
      <Grid item>
        <Typography variant="h4">{getSuccessMessage()}</Typography>
      </Grid>
      {submittedAppraisalId && (
        <Grid item>
          <Typography>
            Your appraisal number is
            <TestDataAttribute id="submittedAppraisalId">
              <b>#{submittedAppraisalId}</b>
            </TestDataAttribute>
          </Typography>
        </Grid>
      )}
      <Grid item>
        <Button
          variant="contained"
          type="button"
          color="primary"
          onClick={startAnotherOrder}
          testId="startOrder"
        >
          Start another Order
        </Button>
      </Grid>
    </Grid>
  );
});
